import { hasAdminPermission } from './adminPermissions';

export const canManageUserRecords = (user) => hasAdminPermission(user, 'manage_users_roles');
